export default "__VITE_ASSET__OwfBPFdF__"